import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientPaymentList = createAsyncThunk("client/get-payment-list", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/get-payment-list`,{
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.documenttype);
    return res.data.paymentList;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client documents");
  }
});

export const getClientAppointmentNotes = createAsyncThunk("client/get-appointment-notes", async (id, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-appointment-notes/${id}`,{
            // headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.documenttype);
    return res.data.providerAppointment;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client documents");
  }
});


const clientPanelListPaymentSlice = createSlice({
  name: "clientListPayment",
    initialState: {
      clientsListPayment: null,
      clientAppointmentNotes: null,
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getClientPaymentList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientPaymentList.fulfilled, (state, action) => {
            state.clientsListPayment = action.payload;
            state.loading = false;
        })
        .addCase(getClientPaymentList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch client self assessment"; 
            state.loading = false;
        })
        .addCase(getClientAppointmentNotes.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientAppointmentNotes.fulfilled, (state, action) => {
            state.clientAppointmentNotes = action.payload;
            state.loading = false;
        })
        .addCase(getClientAppointmentNotes.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch client appointment notes"; 
            state.loading = false;
        })
    },
});

export default clientPanelListPaymentSlice.reducer;